<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-13 16:30:53
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-16 14:36:23
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\regionPicker\index.vue
-->
<template>
  <div>
    <DhcFieldInput v-model="formOption" placeholder="请选择地址" :inputData="cascaderValue" :disable="disable" @changeFieldData="changeFieldData"></DhcFieldInput>
    <van-popup v-model="formOption.isPopFlag" round position="bottom">
      <van-cascader v-model="cascaderNum" title="请选择地址" :options="regionColumns" active-color="#1989fa"
                    :field-names="fieldNames" @close="formOption.isPopFlag = false" @finish="onRegionFinish"
      />
    </van-popup>
  </div>
</template>
<script>
import * as dictionary from '@/assets/js/dictionary'
import { regionDataPlus, getRegionValue } from '@/utils/region.js'
export default {
	props: {
		value: {
			type: Object,
			default: {}
		},
		disable: { // 禁止
			type: [Boolean, Number],
			default: false
		}
	},
	data() {
		return {
			dictionary,
			regionColumns: regionDataPlus, // 地址信息
			cascaderValue: '', // 地址选择器对应输入框的显示值
			cascaderNum: '', // 地址选择器的值
			fieldNames: { // 选择地区组件属性
				text: 'label',
				value: 'value',
				children: 'children'
			}
		}
	},
	computed: {
		formOption: {
			get: function() {
				return this.value
			},
			set: function() {
				return
			}
		}
	},
	watch: {
		'formOption': {
			handler(newValue) {
				if (newValue.value && newValue.value.length !== 0) {
					if (typeof newValue.value[0] === 'object') newValue.value = newValue.value[0]
					if (newValue.value[newValue.value.length - 1] === 0 || newValue.value[newValue.value.length - 1] === 1 || newValue.value[newValue.value.length - 1] === '') {
						newValue.value[newValue.value.length - 1] = newValue.value.join('-')
					}
					this.cascaderNum = newValue.value[newValue.value.length - 1]
					this.cascaderValue = getRegionValue(this.regionColumns, newValue.value)
					newValue.value[newValue.value.length - 1] = newValue.value[newValue.value.length - 1].split('-')[newValue.value[newValue.value.length - 1].split('-').length - 1]
				} else {
					this.cascaderNum = ''
					this.cascaderValue = ''
				}
				this.$emit('changePickerData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 地区选择完毕
		onRegionFinish({
			selectedOptions
		}) {
			this.formOption.isPopFlag = false
			this.cascaderValue = selectedOptions.map((option) => option.label).join('/')
			this.formOption.value = selectedOptions.map((item) => {
				return item.value
			})
			this.formOption.value[this.formOption.value.length - 1] = this.formOption.value[this.formOption.value.length - 1].split('-')[this.formOption.value[this.formOption.value.length - 1].split('-').length - 1]
		},
		// 下拉框数据确认
		changeFieldData(data) {
			this.formOption = data
		}
	}
}
</script>
<style lang="scss" scoped>
</style>